module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/modal-5673376f3fe30a191e49551e37e55b1f.svg";